import { Box, Typography } from "@mui/material";
import * as React from "react";
import TextField from "@mui/material/TextField";
import PieChart from "./PieChart";
import Grid from "@mui/material/Unstable_Grid2";

export default function StatsPage() {
  const [tillDate, setTillDate] = React.useState(
    new Date().toLocaleDateString("sv-SE")
  );
  const [fromDate, setFromDate] = React.useState("");

  return (
    <Box sx={{ width: "100%" }}>
      <Grid item xs={12} md={12}>
        <Typography
          sx={{
            minWidth: 230,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "140%",
            mb: "2%",
          }}
        >
          Ergebnisse von Prüfungen in einer Zeitspanne
        </Typography>
      </Grid>

      <TextField
        id="fromDate"
        label="Von"
        type="date"
        value={fromDate}
        sx={{ width: "17%", mr: "0.5%", ml: "32.5%" }}
        InputLabelProps={{
          shrink: true,
        }}
        onInput={(e) => {
          setFromDate(e.target.value);
        }}
      />

      <TextField
        id="tillDate"
        label="Bis"
        type="date"
        value={tillDate}
        sx={{ width: "17%", ml: "0.5%", mb: "1%", mr: "31%" }}
        InputLabelProps={{
          shrink: true,
        }}
        onInput={(e) => {
          setTillDate(e.target.value);
        }}
      />

      <Box sx={{ width: "40%", ml: "30%" }}>
        <PieChart
          tillDate={tillDate}
          setTillDate={setTillDate}
          fromDate={fromDate}
          setFromDate={setFromDate}
        />
      </Box>
    </Box>
  );
}
